import { UploadItemTypeEnum } from '@/Domain/enum/UploadItemType.enum';
import { UploadStatusEnum } from '@/Domain/enum/UploadStatus.enum';

export type StatusIconConfig = {
  icon: string;
  className: string;
  animate?: boolean;
};

export const UploadFileHelper = {
  getFileIcon: (fileName: string, fileType?: UploadItemTypeEnum): string => {
    if (fileType === UploadItemTypeEnum.URL) {
      return 'mingcute:link-line';
    }

    const extension = fileName.split('.').pop()?.toLowerCase() || '';

    switch (extension) {
      case 'pdf':
        return 'mingcute:pdf-fill';
      case 'docx':
      case 'doc':
      case 'odt':
      case 'rtf':
        return 'mingcute:doc-fill';
      case 'pptx':
      case 'ppt':
        return 'mingcute:ppt-fill';
      case 'xlsx':
      case 'xls':
      case 'ods':
      case 'csv':
      case 'tsv':
        return 'mingcute:xls-fill';
      case 'epub':
      case 'fb2':
        return 'mingcute:book-5-fill';
      case 'html':
      case 'htm':
      case 'xml':
      case 'json':
      case 'yaml':
      case 'yml':
      case 'toml':
        return 'mingcute:code-fill';
      case 'txt':
      case 'md':
      case 'markdown':
      case 'rst':
      case 'org':
        return 'mingcute:text-fill';
      case 'eml':
      case 'msg':
        return 'mingcute:mail-fill';
      case 'tex':
      case 'latex':
      case 'ipynb':
      case 'bib':
        return 'mingcute:file-fill';
      case 'png':
      case 'jpg':
      case 'jpeg':
      case 'gif':
      case 'webp':
      case 'bmp':
      case 'tiff':
      case 'tif':
      case 'svg':
        return 'mingcute:image-fill';
      default:
        return 'mingcute:file-fill';
    }
  },

  getFileSizeText: (fileSize: number): string => {
    const sizeMB = fileSize / (1024 * 1024);
    return sizeMB >= 1 ? `${sizeMB.toFixed(1)} MB` : `${(fileSize / 1024).toFixed(1)} KB`;
  },

  isPendingStatus: (status: UploadStatusEnum): boolean =>
    [
      UploadStatusEnum.PENDING,
      UploadStatusEnum.PARSING,
      UploadStatusEnum.PARSING_FALLBACK,
    ].includes(status),

  getStatusIconConfig: (status: UploadStatusEnum): StatusIconConfig | null => {
    if (status === UploadStatusEnum.DONE || status === UploadStatusEnum.DONE_FALLBACK) {
      return {
        icon: 'mingcute:check-circle-fill',
        className: 'text-green-500',
      };
    } else if (status === UploadStatusEnum.ERROR) {
      return {
        icon: 'mingcute:alert-fill',
        className: 'text-red-500',
      };
    } else if (UploadFileHelper.isPendingStatus(status)) {
      return {
        icon: 'mingcute:loading-fill',
        className: 'text-neutral-800',
        animate: true,
      };
    }

    return null;
  },
};
